import React from "react";
import styles from "./Banner.module.css";

export default function Banner() {
  return (
    <section className={styles.hero}>
      <div className={styles.container}>
        <div className={styles.heroText}>
          <h1>
            <span className={styles.accent}> IMPARC Annual </span>
            <span className={styles.accent2}> Academic Excellence Awards</span>
          </h1>
          <p>
           Recognizing Global Leadership. Advancing Research. Celebrating Impact. <br/><br/>
The Ignited Minds Global Academic Excellence Awards (IM-GAEA) is an international recognition platform honoring individuals, institutions, and academic leaders who demonstrate exceptional contributions to higher education, research advancement, innovation, mentorship, and institutional transformation.<br/><br/>
IM-GAEA celebrates integrity, measurable impact, and forward-looking academic excellence through a structured, merit-based evaluation framework aligned with global standards.

          </p>
          <div className={styles.heroActions}>
            <button className={`${styles.button} ${styles.orange}`}>
              Nominate Now
            </button>
            <button className={styles.button}>View Categories</button>
          </div>
        </div>
      </div>
    </section>
  );
}
